import { Reveal } from "../components/Reveal";

const steps = [
  { n: "1", title: "Anschauen", text: "Gemeinsam durch die Bilder blättern und Motive entdecken.", c: "#D95338" },
  { n: "2", title: "Benennen", text: "Farben, Tiere und Dinge gemeinsam aussprechen und zeigen.", c: "#3A7BD5" },
  { n: "3", title: "Mitsingen", text: "Den passenden Lernsong starten und die Inhalte gemeinsam wiederentdecken.", c: "#4A8B5D" },
];

export const HowItWorks = () => (
  <section className="py-24 sm:py-32" id="so-funktioniert" data-testid="how-section">
    <div className="max-w-6xl mx-auto px-5 lg:px-8">
      <Reveal className="mb-14">
        <p className="eyebrow-label mb-5">So einfach geht's</p>
        <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08]">
          So funktioniert eine<br />VisualMA <em style={{ color: "var(--terra)" }}>Lernwelt.</em>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="card-soft p-8 h-full relative overflow-hidden" data-testid={`how-step-${s.n}`}>
              <span
                className="font-display italic font-semibold text-[80px] leading-none absolute -top-3 right-4 opacity-15 select-none"
                style={{ color: s.c }}
              >
                {s.n}
              </span>
              <span className="w-9 h-9 rounded-full flex items-center justify-center text-white text-sm font-bold mb-6" style={{ background: s.c }}>
                {s.n}
              </span>
              <h3 className="font-display text-2xl font-medium mb-2.5">{s.title}</h3>
              <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
